import type { SideBarItemProps } from 'src/utils/advisor-dash-nav/side-bar';

import { OVERVIEW_TAB_TITLE } from './get-active-tab';

// `getSideBarItems` interpolates ids straight into paths, so an id that has not resolved leaves a
// live-looking `.../portfolio/undefined` behind. The nav renders that as a link the advisor has to
// choose to click; landing on it would make a 404 the household's default page.
function hasUnresolvedSegment(path: string): boolean {
  return path.split('/').includes('undefined');
}

/**
 * Where opening a household should land, or `null` to stay on Overview.
 *
 * Picks the first *enabled* tab: `sortedActiveItems` pushes disabled tabs to the end of the rendered
 * row after `applyTabOrder` has run, and landing has to agree with what the advisor sees. Reads
 * `path` off the item rather than rebuilding it, because Portfolio resolves to
 * `portfolio/:personalPortfolioId` or `net-worth` depending on the household.
 */
export function householdLandingTabPath(navItems: readonly SideBarItemProps[]): string | null {
  const first = navItems.find((item) => item.disabled !== true);
  // Overview is the base route itself, so landing on it is what already happens.
  if (!first || first.title === OVERVIEW_TAB_TITLE) return null;
  if (first.path === undefined || hasUnresolvedSegment(first.path)) return null;
  return first.path;
}
